/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/ZeroDataItem" />
import * as React from "react";
import { IZeroDataItemProps } from "Wit/Settings/BoardsExternalIntegration/components/ZeroDataItem.Props";

export class ZeroDataItem extends React.Component<IZeroDataItemProps> {
    public render(): JSX.Element {
        const item = this.props.item;
        const secondary: JSX.Element = item.secondaryText! as JSX.Element;

        return (
            <div className={"boards-zeroDataItem"}>
                <img className="boards-ZeroDataItem--image" src={item.imagePath} alt={item.imageAltText} />
                <div>
                    <div className={"boards-zeroDataItem--primary font-size-lll font-weight-heavy"}>{item.primaryText}</div>
                    {secondary && <div className="boards-zeroDataItem--secondary font-size-m">{secondary}</div>}
                </div>
            </div>
        );
    }
}
